import React from 'react';
import { Database } from 'lucide-react';
import CSVImport from '../CSVImport';
import AICVIngestion from '../AICVIngestion';
import { Separator } from '../../ui/separator';

const BulkUpload = () => {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-medium">Bulk Upload</h3>
        <p className="text-sm text-muted-foreground">
          Import multiple records at once using CSV files or AI-powered resume ingestion
        </p>
      </div>

      {/* AI Resume Ingestion Section */}
      <AICVIngestion />

      <Separator />

      {/* CSV Import Section */}
      <div className="space-y-4">
        <div>
          <h4 className="text-base font-medium">CSV Import</h4>
          <p className="text-sm text-muted-foreground">
            Import RFQs, clients, and candidates using structured CSV files
          </p>
        </div>
        <CSVImport />
      </div>
    </div>
  );
};

export default BulkUpload;
